import { withIdentities } from './withIdentities';
export function withIdentity(key, value) {
    var _a;
    return withIdentities((_a = {}, _a[key] = value, _a));
}
//# sourceMappingURL=withIdentity.js.map